/* eslint-disable no-underscore-dangle */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable import/no-cycle */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-console */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Checkbox,
  Avatar,
  Modal,
  TableHead,
  TextField,
  List,
  ListItemButton,
  ListItemText,
  ListItemAvatar,
  styled
} from '@mui/material';
import dayjs from 'dayjs';
import SendIcon from '@mui/icons-material/Send';
import useSWR from 'swr';
import { ReactComponent as ChevronDownIcon } from '../../../assets/icons/chevron-down.svg';
import {
  mainColors,
  secondaryColors,
  surfaceColors,
  textColors,
  themePalette
} from '../../../theme/themeConfig';
import {
  TaskStatus,
  TaskStyle,
  capitalizeString,
  convertTo12HourFormat,
  getPluralMeasure,
  getTimeFromISO8601,
  resourseColors,
  taskInteractionStyles
} from '../../../utils/general';
import Chat from '../../leads/steps/components/Chat';
import { formatDate, formatSumTime } from '../../../utils/calendarHelper';
import Api from '../../../api';
import {
  TaskIterationStatusStatusEnum,
  TimeFormatEnum
} from '../../../api-client/generated/api';
import { DrawerButton } from '../../../components/modals/GlobalConfirmModal';
import ImageViewer from '../../../components/ImageViewer';
import ReassignTechnicianModal from '../../../components/modals/ReassignTechnicianModal';
import ProjectTaskDetailsModal from './ProjectTaskDetailsModal';
import { getWorkedTimeAverageTime } from '../../../utils/calculatorHelper';
import AvatarGroup from '../../../components/AvatarGroup';
import useAuthStore from '../../../store/zustand/auth';

export interface NoteResponseDTO {
  createdAt: string;
  id: string;
  noteText: string;
  updatedAt: string;
  user: object;
}

const ListItem = styled(Box)(() => ({
  backgroundColor: 'white',
  border: 'solid',
  borderColor: secondaryColors.SECONDARY,
  borderRadius: '2px',
  borderWidth: '1px',
  display: 'flex',
  marginTop: '0.5rem',
  width: '100%'
}));

const ListHead = styled(TableHead)(() => ({
  '.MuiTableHead-root': { boxShadow: 0 },
  display: 'flex',
  width: '100%'
}));

const ListTitle = styled(Typography)(() => ({
  color: textColors.DARK_TEXT,
  fontFamily: 'Lexend',
  fontSize: '28px',
  fontWeight: '600',
  marginLeft: '1rem'
}));

const TaskImageListContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(1.5),
  gridTemplateColumns: `repeat(auto-fill, minmax(${theme.spacing(7)}, 2fr))`,
  padding: theme.spacing(1.5)
}));

const TaskImageContainer = styled(Box)(({ theme }) => ({
  '&:hover': {
    transform: 'scale(1.1)'
  },
  alignContent: 'center',
  alignItems: 'center',
  border: `1px solid ${theme.palette.secondary[100]}`,
  cursor: 'pointer',
  display: 'flex',
  height: theme.spacing(7),
  justifyContent: 'center',
  marginRight: '5px',
  overflow: 'hidden',
  transition: '1s ease',
  width: theme.spacing(7)
}));

interface IServiceTableBlockCheck {
  isCheked: boolean;
  text: string;
}

interface IServiceTableBlock {
  checklist?: Array<IServiceTableBlockCheck> | [];
  images?: any;
  materials?: any;
  note?: any;
  taskIterationID?: any;
  title: string;
  type: string;
}
type VariantType = 'secondary-bold' | 'secondary';

interface IServiceTableRowTD {
  children?: any;
  colorH: string;
  fontSize: string;
  minWidth?: number;
  text?: string;
  typeTx?: VariantType;
  width: number;
}

interface Props {
  calendarEvenState: string | undefined;
  dashboard: any;
  mutateAction: () => void;
  onlyTask: boolean;
  serviceInfo: any;
  typeView: string;
}

const ServiceTable: React.FC<Props> = function ServiceTable({
  dashboard,
  mutateAction,
  onlyTask,
  serviceInfo,
  calendarEvenState,
  typeView
}) {
  const [reassignFlag, setReassignFlag] = useState<boolean>(false);
  const [openTaskDetails, setOpenTaskDetails] = useState<boolean>(false);
  const [taskData, setTaskData] = useState<any>();
  const userState = useAuthStore((state) => state);

  const getTaskStyle = (task: TaskStatus): TaskStyle => {
    return taskInteractionStyles[task] || taskInteractionStyles.awaiting;
  };

  function ServiceTableBlockCheck({ isCheked, text }: IServiceTableBlockCheck) {
    return (
      <Box
        style={{
          alignContent: 'center',
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start'
        }}
      >
        <Checkbox
          disabled
          checked={isCheked}
          onChange={() => {}}
          size="small"
        />
        <Typography align="left" style={{ color: '#4B4D56', fontSize: '12px' }}>
          {text}
        </Typography>
      </Box>
    );
  }

  function ServiceTableBlock({
    title,
    type,
    materials,
    taskIterationID,
    checklist,
    note,
    images
  }: IServiceTableBlock) {
    const [modalOpen, setModalOpen] = useState(false); // Estado para controlar si el modal está abierto
    const [selectedNote, setSelectedNote] = useState<NoteResponseDTO[]>([]);
    const [fireCreateNote, setFireCreateNote] = useState<boolean>(false);
    const [noteText, setNoteText] = useState<string>('');
    // eslint-disable-next-line no-unused-vars
    const [currentTaskDetails, setCurrentTaskDetails] = useState<any>({});
    const [imgData, setImgData] = useState('');
    const [isImageViewerOpen, setIsImageViewerOpen] = useState(false);

    const { data: createTaskNoteData, error: createTaskNoteDataError } = useSWR(
      fireCreateNote && noteText !== '' && taskIterationID
        ? {
            entity: 'taskIteration',
            entityId: `${taskIterationID}`,
            noteText: `${noteText}`,
            taskIterationId: Number(taskIterationID) ?? 0
          }
        : null,
      Api.CalendarApi.noteCreate
    );

    // Función para manejar el clic en el icono de agregar
    const handleAddIconClick = (note: any) => {
      setSelectedNote(note); // Establece la nota seleccionada
      setModalOpen(true); // Abre el modal
    };

    // eslint-disable-next-line no-unused-vars
    const filteredDashboard = dashboard.filter((task: any) => {
      // Verificar si el objeto task tiene un array taskIteration
      if (task.taskIteration && task.taskIteration.length > 0) {
        // Verificar si algún elemento en el array taskIteration tiene un id igual a taskIterationId
        return task.taskIteration.some(
          (iteration: any) => iteration.id === taskIterationID
        );
      }
      return false; // Si no hay taskIteration o está vacío, devolver falso
    });
    useEffect(() => {
      if (createTaskNoteData && !createTaskNoteDataError) {
        const auxNotes = [...selectedNote, createTaskNoteData];
        setSelectedNote(auxNotes);
        setNoteText('');
        setFireCreateNote(false);
      }
    }, [createTaskNoteData, createTaskNoteDataError, selectedNote, noteText]);

    return (
      <Box
        maxWidth="34%"
        minWidth="25%"
        style={{
          backgroundColor: `${secondaryColors.SECONDARY_6}`,
          borderRight: `solid 1px ${secondaryColors.SECONDARY_1}`
        }}
        width="34%"
      >
        <Box
          style={{
            borderBottom: `solid 1px ${secondaryColors.SECONDARY_1}`,
            padding: '12px'
          }}
        >
          <Typography
            style={{
              color: `${secondaryColors.SECONDARY_5}`,
              fontSize: '11px'
            }}
            variant="secondary-bold"
          >
            {title}
          </Typography>
        </Box>

        {type === 'materials' && (
          <Box style={{ padding: '12px' }}>
            {materials &&
              materials?.map((index: any, key: number) => (
                <Typography
                  component="li"
                  key={key}
                  style={{
                    color: `${secondaryColors.SECONDARY_5}`,
                    fontSize: '12px'
                  }}
                  variant="secondary"
                >
                  {index?.name}
                </Typography>
              ))}
          </Box>
        )}

        {type === 'note' && (
          <>
            <Box style={{ padding: '12px' }}>
              {note && note.length > 0 && (
                <Typography
                  component="li"
                  style={{
                    color: `${secondaryColors.SECONDARY_5}`,
                    fontSize: '12px'
                  }}
                  variant="secondary"
                >
                  {note[0].noteText}
                </Typography>
              )}
              <Box
                style={{
                  display: 'flex',
                  marginBottom: '-24px',
                  paddingTop: '20px'
                }}
              >
                {note && note.length > 0 && (
                  <DrawerButton
                    onClick={() => handleAddIconClick(note)}
                    sx={{
                      height: '28px !important'
                    }}
                    variant="primary"
                  >
                    <Typography fontSize={11}>Open Notes</Typography>
                  </DrawerButton>
                )}
              </Box>
            </Box>
            <Box>
              {modalOpen && (
                <Modal
                  onClose={() => {
                    setModalOpen(false);
                    mutateAction();
                  }}
                  open={modalOpen}
                  sx={{
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'center'
                  }}
                >
                  <Box
                    sx={{
                      '.textAreaInput-taskDetails': {
                        // backgroundColor: `${textColors.TEXT} !important`,
                        // backgroundColor: 'red',
                        fontSize: '16px !important',
                        padding: '0px !important'
                      }
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: surfaceColors.SURFACE_6,

                        borderRadius: 2,
                        height: 600,
                        p: 4,
                        width: 800
                      }}
                    >
                      {
                        <Box>
                          <Box
                            sx={{
                              alignItems: 'center',
                              display: 'grid',
                              padding: '0.5rem 2rem 1.5rem 2rem;'
                            }}
                          >
                            <ListHead>
                              <Box>
                                <ListTitle variant="primary">Notes</ListTitle>
                              </Box>
                            </ListHead>
                            <Box
                              sx={{
                                border: 'solid 1px rgba(203, 204, 211, 0.7)',
                                borderRadius: '3px',
                                marginTop: '22px',
                                maxHeight:
                                  selectedNote && selectedNote.length > 3
                                    ? '350px'
                                    : 'auto',
                                overflowY:
                                  selectedNote && selectedNote.length > 3
                                    ? 'auto'
                                    : 'visible',
                                padding: '13px'
                              }}
                            >
                              <List dense sx={{ borderRadius: '8px' }}>
                                {selectedNote &&
                                  selectedNote?.length > 0 &&
                                  selectedNote
                                    .sort(
                                      (a, b) =>
                                        new Date(b.updatedAt).getTime() -
                                        new Date(a.updatedAt).getTime()
                                    )

                                    .map((noteData: any, index: number) => {
                                      const initials =
                                        `${noteData?.user?.firstName} ${noteData?.user?.lastName}`
                                          .toUpperCase()
                                          .split(' ')
                                          .slice(0, 2)
                                          .map((word: string) =>
                                            word[0]?.toUpperCase()
                                          )
                                          .join('');
                                      const auxKey = `avatar-technician-${index}`;
                                      return (
                                        <ListItem
                                          key={`task-details-note-listItem-${noteData.id}`}
                                          sx={{
                                            borderColor: `${secondaryColors.SECONDARY_1} !important`,
                                            borderRadius: '4px',
                                            width: '100% !important'
                                          }}
                                        >
                                          <ListItemButton
                                            sx={{
                                              backgroundColor: 'white',
                                              display: 'ruby-text !important',
                                              width: 'fit-content !important'
                                            }}
                                          >
                                            <Box sx={{ display: 'flex' }}>
                                              <ListItemAvatar
                                                style={{ paddingTop: '5px' }}
                                              >
                                                <Avatar
                                                  alt={`${noteData?.user?.firstName} ${noteData?.user?.lastName}`}
                                                  key={auxKey}
                                                  src={`${
                                                    noteData?.user?.fileBank
                                                      .length > 0
                                                      ? noteData?.user
                                                          ?.fileBank[0]?.fileUrl
                                                      : ''
                                                  }`}
                                                  sx={{
                                                    marginRight: '-20px'
                                                  }}
                                                >
                                                  {noteData?.user?.fileBank[0]
                                                    ?.fileUrl
                                                    ? null
                                                    : initials}
                                                </Avatar>
                                              </ListItemAvatar>
                                              <ListItemText
                                                id={`${noteData?.id}-title`}
                                                primary={`${
                                                  noteData?.user?.firstName
                                                } ${
                                                  noteData?.user?.lastName
                                                  // eslint-disable-next-line no-undef
                                                } - ${formatDate(
                                                  new Date(noteData?.createdAt)
                                                )} ${getTimeFromISO8601(
                                                  noteData?.createdAt,
                                                  userState?.timeFormat
                                                )}`}
                                                sx={{
                                                  '.MuiListItemText-primary': {
                                                    color: `${secondaryColors.SECONDARY} !important`,
                                                    fontSize: '14px !important',
                                                    textTransform:
                                                      'capitalize !important'
                                                  }
                                                }}
                                              />
                                            </Box>
                                            <ListItemText
                                              id={`${noteData?.id}-text`}
                                              primary=""
                                              secondary={`${noteData.noteText}`}
                                              sx={{
                                                '.MuiListItemText-secondary': {
                                                  color: `${secondaryColors.SECONDARY} !important`,
                                                  fontSize: '1rem !important'
                                                },
                                                textAlign: 'justify'
                                              }}
                                            />
                                          </ListItemButton>
                                        </ListItem>
                                      );
                                    })}
                              </List>
                            </Box>
                            <Box
                              sx={{
                                alignItems: 'center',
                                display: 'flex',
                                paddingTop: '17px'
                              }}
                            >
                              <TextField
                                fullWidth
                                multiline
                                className="textAreaInput-taskDetails"
                                disabled={
                                  currentTaskDetails?.status ===
                                  TaskIterationStatusStatusEnum.Created
                                }
                                id="outlined-multiline-static"
                                label=""
                                maxRows={2}
                                onChange={(textField) => {
                                  setNoteText(textField.target.value);
                                }}
                                placeholder="Write here"
                                rows={1}
                                sx={{
                                  backgroundColor: 'white !important',
                                  fontSize: '16px',
                                  minHeight: 'auto',
                                  padding: '0rem 2rem 1.5rem 2rem !important',
                                  width: '100%'
                                }}
                                value={noteText}
                                variant="outlined"
                              />
                              <Button
                                fullWidth
                                onClick={() => {
                                  setFireCreateNote(true);
                                  // setModalOpen(false);
                                }}
                                sx={{
                                  '&:hover': {
                                    backgroundColor: 'transparent'
                                  },
                                  alignItems: 'center',
                                  backgroundColor: 'transparent',
                                  margin: '0 !important',
                                  minWidth: '2.5rem',
                                  padding: '0 !important',
                                  width: 'auto'
                                }}
                                variant="primary"
                              >
                                <SendIcon
                                  sx={{
                                    color: mainColors.MAIN,
                                    fontSize: '2.25rem',
                                    margin: '0px',
                                    padding: '0px'
                                  }}
                                />
                              </Button>
                            </Box>
                          </Box>
                        </Box>
                      }
                    </Box>
                  </Box>
                </Modal>
              )}
            </Box>
          </>
        )}

        {type === 'checklist' && (
          <Box style={{ padding: '12px' }}>
            {checklist &&
              checklist?.map((index: any, key: number) => {
                return (
                  <ServiceTableBlockCheck
                    isCheked={index?.checked}
                    key={key}
                    text={index?.name}
                  />
                );
              })}
          </Box>
        )}

        {type === 'images' && (
          <>
            <TaskImageListContainer>
              {images.map((image: any, _key: number) => {
                return (
                  <Box
                    style={{
                      alignContent: 'center',
                      alignItems: 'center',
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'flex-start'
                    }}
                  >
                    <TaskImageContainer
                      onClick={() => {
                        setIsImageViewerOpen(true);
                        setImgData(image?.large || image?.fileUrl);
                      }}
                    >
                      <img
                        alt={image.fileName}
                        key={`taskIteration-image-${image.id}}`}
                        src={image.small || image.fileUrl}
                      />
                    </TaskImageContainer>
                  </Box>
                );
              })}
            </TaskImageListContainer>
            <Box>
              {isImageViewerOpen && imgData !== '' && (
                <ImageViewer
                  isOpen={isImageViewerOpen}
                  setIsOpen={setIsImageViewerOpen}
                  url={imgData}
                />
              )}
            </Box>
          </>
        )}
      </Box>
    );
  }

  // eslint-disable-next-line prettier/prettier
  function ServiceTableRowTD({
    width,
    fontSize,
    colorH,
    typeTx,
    text,
    children,
    minWidth
  }: IServiceTableRowTD) {
    return (
      <Box
        style={{
          alignItems: 'center',
          display: 'flex',
          height: '100%',
          minWidth,
          padding: '6px 10px',
          width: `${width}%`
        }}
      >
        <Typography color={colorH} fontSize={fontSize} variant={typeTx}>
          {text}
          {children}
        </Typography>
      </Box>
    );
  }

  function ServiceTableHeader() {
    const cols = [
      { label: 'TASK', w: 24 },
      { label: 'EST.', w: 9 },
      { label: 'WORKED', w: 9 },
      { label: 'STATUS', w: 11 },
      { label: 'TIME IN/OUT', w: 14 },
      { label: 'CHECKLIST', w: 9 },
      { label: 'GEO', w: 5 },
      { label: 'IMGS', w: 7 },
      { label: 'NOTES', w: 7 },
      { label: '', w: 5 }
    ];
    return (
      <Box
        sx={{
          backgroundColor: '#F5F6F8',
          borderBottom: '1px solid #E2E4EA',
          display: 'flex',
          flexDirection: 'row',
          height: '32px',
          width: '100%'
        }}
      >
        {cols.map(({ label, w }) => (
          <Box
            key={label || 'chevron'}
            sx={{
              alignItems: 'center',
              display: 'flex',
              padding: '0 10px',
              width: `${w}%`
            }}
          >
            <Typography
              color={secondaryColors.SECONDARY}
              fontSize="10px"
              fontWeight={700}
            >
              {label}
            </Typography>
          </Box>
        ))}
      </Box>
    );
  }

  const taskStatusBox = (
    taskIterationLists: any[],
    countTechnicians: number
  ) => {
    const completed = taskIterationLists.filter(
      (taskIte: any) => taskIte.status === 'completed'
    );
    const created = taskIterationLists.filter(
      (taskIte: any) => taskIte.status === 'created'
    );
    const inProgress = taskIterationLists.filter(
      (taskIte: any) => taskIte.status === 'inProgress'
    );
    let auxStatus: TaskStatus = 'awaiting';

    if (
      completed.length > 0 &&
      inProgress.length === 0 &&
      created.length === 0 &&
      countTechnicians === completed.length
    ) {
      auxStatus = 'completed';
    }

    if (
      inProgress.length > 0 ||
      (created.length > 0 && completed.length > 0) ||
      (completed.length > 0 && completed.length < countTechnicians)
    ) {
      auxStatus = 'inProgress';
    }

    return (
      <Box
        style={{
          backgroundColor: getTaskStyle(auxStatus)?.backgroundColor,
          border: `solid 2px ${getTaskStyle(auxStatus)?.borderColor}`,
          borderRadius: '12px',
          display: 'flex',
          justifyContent: 'center',
          marginTop: '-4px',
          padding: '4px 8px'
        }}
      >
        <Typography
          fontSize={11}
          style={{
            color: getTaskStyle(auxStatus).textColor
          }}
        >
          {calendarEvenState === 'Created'
            ? 'Awaiting'
            : capitalizeString(auxStatus)}
        </Typography>
      </Box>
    );
  };

  function ServiceTableBody({ data, taskIteration, onlyTask }: any) {
    const iterations: any[] = Array.isArray(taskIteration) ? taskIteration : [];
    const hasIterations = iterations.length > 0;
    const techCount = data?.technicians?.length || data?.minimumResources || 1;

    // Time computations
    const auxTaskHours =
      data?.technicians?.length > 0
        ? data?.totalTimeInHours / data?.technicians?.length
        : data?.totalTimeInHours / (data?.minimumResources || 1);
    const estMinutes = auxTaskHours * 60;
    const sumWorkedMinutes = hasIterations
      ? getWorkedTimeAverageTime(iterations)
      : 0;

    // Derive aggregate status
    const completedIters = iterations.filter(
      (i: any) => i.status === 'completed'
    );
    const inProgressIters = iterations.filter(
      (i: any) => i.status === 'inProgress'
    );
    const createdIters = iterations.filter((i: any) => i.status === 'created');
    let derivedStatus: TaskStatus = 'awaiting';
    if (
      completedIters.length > 0 &&
      inProgressIters.length === 0 &&
      createdIters.length === 0 &&
      techCount === completedIters.length
    )
      derivedStatus = 'completed';
    if (
      inProgressIters.length > 0 ||
      (createdIters.length > 0 && completedIters.length > 0) ||
      (completedIters.length > 0 && completedIters.length < techCount)
    )
      derivedStatus = 'inProgress';
    const displayStatus =
      calendarEvenState === 'Created' ? 'awaiting' : derivedStatus;

    // TIME IN/OUT – earliest startTime / latest endTime
    const startTimes = iterations.map((i: any) => i.startTime).filter(Boolean);
    const endTimes = iterations.map((i: any) => i.endTime).filter(Boolean);
    const checkInTime =
      startTimes.length > 0
        ? getTimeFromISO8601(
            startTimes.reduce((a: string, b: string) =>
              new Date(a) < new Date(b) ? a : b
            ),
            userState?.timeFormat
          )
        : '';
    const checkOutTime =
      endTimes.length > 0
        ? getTimeFromISO8601(
            endTimes.reduce((a: string, b: string) =>
              new Date(a) > new Date(b) ? a : b
            ),
            userState?.timeFormat
          )
        : '';

    // CHECKLIST aggregation
    let clChecked = 0;
    let clTotal = 0;
    iterations.forEach((iter: any) => {
      if (iter.checkList?.length > 0) {
        clTotal += iter.checkList.length;
        clChecked += iter.checkList.filter((c: any) => c.checked).length;
      }
    });

    // GEO aggregation
    const geoApproved = iterations.filter(
      (i: any) => i.geofencingApproved === true
    ).length;

    // IMGS
    const imgCount = iterations.reduce(
      (sum: number, i: any) => sum + (i.fileBank?.length || 0),
      0
    );

    // NOTES
    const hasNotes = iterations.some((i: any) => i.notes?.length > 0);

    const taskStyle = getTaskStyle(displayStatus);

    if (typeView === 'serviceTime') {
      return (
        <Box
          onClick={() => {
            if (hasIterations && !onlyTask) {
              setTaskData(data);
              setOpenTaskDetails(true);
            }
          }}
          sx={{
            '&:hover':
              hasIterations && !onlyTask ? { backgroundColor: '#F5F8FF' } : {},
            borderBottom: '1px solid #F0F1F3',
            cursor: hasIterations && !onlyTask ? 'pointer' : 'default',
            display: 'flex',
            flexDirection: 'row',
            minHeight: '44px',
            width: '100%'
          }}
        >
          {/* TASK 24% */}
          <Box
            sx={{
              alignItems: 'flex-start',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              padding: '6px 10px',
              width: '24%'
            }}
          >
            <Typography
              sx={{ color: '#0f1c2e', fontSize: '13px', fontWeight: 600 }}
            >
              {capitalizeString(data?.name)}
            </Typography>
            <Typography sx={{ color: '#7D8090', fontSize: '11px' }}>
              {data?.technicians?.length || data?.minimumResources || 1}{' '}
              technician
              {(data?.technicians?.length || data?.minimumResources || 1) !== 1
                ? 's'
                : ''}
            </Typography>
          </Box>

          {/* EST. 9% */}
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              padding: '6px 10px',
              width: '9%'
            }}
          >
            <Typography sx={{ color: '#4B4D56', fontSize: '12px' }}>
              {formatSumTime(estMinutes)}
            </Typography>
          </Box>

          {/* WORKED 9% */}
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              padding: '6px 10px',
              width: '9%'
            }}
          >
            {hasIterations && sumWorkedMinutes > 0 ? (
              <Typography
                sx={{ color: '#189A90', fontSize: '12px', fontWeight: 700 }}
              >
                {formatSumTime(sumWorkedMinutes)}
              </Typography>
            ) : (
              <Typography sx={{ color: '#CBCCD3', fontSize: '12px' }}>
                —
              </Typography>
            )}
          </Box>

          {/* STATUS 11% */}
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              padding: '6px 10px',
              width: '11%'
            }}
          >
            <Box
              sx={{
                backgroundColor: taskStyle.backgroundColor,
                border: `1px solid ${taskStyle.borderColor}`,
                borderRadius: '20px',
                px: '8px',
                py: '3px'
              }}
            >
              <Typography
                sx={{
                  color: taskStyle.textColor,
                  fontSize: '11px',
                  fontWeight: 600
                }}
              >
                {capitalizeString(displayStatus)}
              </Typography>
            </Box>
          </Box>

          {/* TIME IN/OUT 14% */}
          <Box
            sx={{
              alignItems: 'flex-start',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              padding: '6px 10px',
              width: '14%'
            }}
          >
            {checkInTime ? (
              <>
                <Typography sx={{ color: '#4B4D56', fontSize: '11px' }}>
                  {checkInTime}
                </Typography>
                {checkOutTime && (
                  <Typography sx={{ color: '#7D8090', fontSize: '11px' }}>
                    {checkOutTime}
                  </Typography>
                )}
              </>
            ) : (
              <Typography sx={{ color: '#CBCCD3', fontSize: '12px' }}>
                —
              </Typography>
            )}
          </Box>

          {/* CHECKLIST 9% */}
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              padding: '6px 10px',
              width: '9%'
            }}
          >
            {clTotal > 0 ? (
              <Box sx={{ alignItems: 'center', display: 'flex', gap: '3px' }}>
                <Typography
                  sx={{
                    color: clChecked === clTotal ? '#189A90' : '#E79137',
                    fontSize: '12px',
                    fontWeight: 600
                  }}
                >
                  {clChecked}/{clTotal}
                </Typography>
              </Box>
            ) : (
              <Typography sx={{ color: '#CBCCD3', fontSize: '12px' }}>
                {hasIterations ? '—' : '—'}
              </Typography>
            )}
          </Box>

          {/* GEO 5% */}
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'center',
              padding: '6px 4px',
              width: '5%'
            }}
          >
            {hasIterations ? (
              <i
                className="custom-icon icon-location"
                style={{
                  color:
                    geoApproved === iterations.length
                      ? '#189A90'
                      : geoApproved > 0
                      ? '#E79137'
                      : '#CBCCD3',
                  fontSize: 16
                }}
              />
            ) : (
              <Typography sx={{ color: '#CBCCD3', fontSize: '12px' }}>
                —
              </Typography>
            )}
          </Box>

          {/* IMGS 7% */}
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              gap: '3px',
              padding: '6px 6px',
              width: '7%'
            }}
          >
            <i
              className="custom-icon icon-photo-upload"
              style={{
                color: imgCount > 0 ? '#005DA2' : '#CBCCD3',
                fontSize: 15
              }}
            />
            {imgCount > 0 && (
              <Typography
                sx={{ color: '#005DA2', fontSize: '11px', fontWeight: 600 }}
              >
                {imgCount}
              </Typography>
            )}
          </Box>

          {/* NOTES 7% */}
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'center',
              padding: '6px 4px',
              width: '7%'
            }}
          >
            {hasIterations ? (
              <i
                className="custom-icon icon-eye"
                style={{
                  color: hasNotes ? '#189A90' : '#CBCCD3',
                  fontSize: 15
                }}
              />
            ) : (
              <Typography sx={{ color: '#CBCCD3', fontSize: '12px' }}>
                —
              </Typography>
            )}
          </Box>

          {/* EXPAND 5% */}
          <Box
            onClick={(e) => e.stopPropagation()}
            sx={{
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'center',
              width: '5%'
            }}
          >
            {hasIterations && !onlyTask && (
              <Button
                onClick={() => {
                  setTaskData(data);
                  setOpenTaskDetails(true);
                }}
                size="small"
                sx={{
                  '&:hover': { borderColor: '#005DA2' },
                  border: '1px solid #E2E4EA',
                  borderRadius: '6px',
                  height: '28px',
                  minWidth: 0,
                  padding: 0,
                  width: '28px'
                }}
              >
                <ChevronDownIcon />
              </Button>
            )}
          </Box>
        </Box>
      );
    }

    // ── serviceSetup view – original layout ──────────────────────────────
    const formattedTime = (() => {
      const totalTimeInMinutes = auxTaskHours * 60;
      const hours = Math.floor(totalTimeInMinutes / 60);
      const minutes = totalTimeInMinutes % 60;
      return dayjs().set('hour', hours).set('minute', minutes).format('HH:mm');
    })();

    return (
      <Box>
        <Box
          sx={{
            '&:hover': { backgroundColor: '#FAFBFC' },
            borderBottom: '1px solid #F0F1F3',
            display: 'flex',
            flexDirection: 'row',
            minHeight: '44px',
            width: '100%'
          }}
        >
          <ServiceTableRowTD
            colorH={`${secondaryColors.SECONDARY}`}
            fontSize="12px"
            text={capitalizeString(data?.name)}
            typeTx="secondary"
            width={23}
          />
          <ServiceTableRowTD
            colorH={`${secondaryColors.SECONDARY}`}
            fontSize="9px"
            minWidth={150}
            text={`${
              serviceInfo?.formatedStartTime || serviceInfo?.startTime || ''
            } - ${serviceInfo?.formatedEndTime || serviceInfo?.endTime || ''}`}
            typeTx="secondary"
            width={20}
          />
        </Box>
      </Box>
    );
  }

  const getReassignModal = () => {
    return (
      <ReassignTechnicianModal
        data={taskData}
        mutate={mutateAction}
        setShowModal={setReassignFlag}
      />
    );
  };

  return (
    <Box
      sx={{
        borderTop: '1px solid #E2E4EA'
      }}
    >
      {reassignFlag && getReassignModal()}
      {openTaskDetails && (
        <ProjectTaskDetailsModal
          calendarEvenState={calendarEvenState}
          dashboard={dashboard}
          data={taskData}
          mutateAction={mutateAction}
          onlyTask={onlyTask}
          serviceInfo={serviceInfo}
          setShowModal={setOpenTaskDetails}
        />
      )}
      <ServiceTableHeader />
      {dashboard.map((index: any, key: number) => {
        return (
          <ServiceTableBody
            dashboard={dashboard}
            data={index}
            key={key}
            onlyTask={onlyTask}
            taskIteration={onlyTask === true ? index : index.taskIteration}
          />
        );
      })}
    </Box>
  );
};

export default ServiceTable;
